<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">My Tasks</span>
    <a
      routerLink="/profile/my-tasks"
      [queryParams]="{ _ref: 'dashboard' }"
      class="rounded border border-transparent px-2 py-0.5 text-sm text-gray-400 transition hover:border-gray-200 hover:text-primary"
      >View all</a
    >
  </div>
  <div class="flex-1 overflow-y-auto">
    @if (dataLoader) {
      <div class="flex h-full items-center justify-center">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
      </div>
    }
    @if (myTasks?.length && !dataLoader) {
      @for (task of myTasks; track task.id) {
        <a class="flex cursor-pointer flex-col gap-1 border-b px-4 py-1 last:border-b-0 hover:bg-gray-50" [routerLink]="['/tasks/detail', task.id]" [queryParams]="{ _ref: 'dashboard' }">
          <div class="flex items-center gap-1.5">
            <span [class]="'rounded-full px-2.5 py-0.5 text-xs font-semibold ' + (task.priority | badge)">{{ task.priority }}</span>
            <span [class]="'rounded-full px-2.5 py-0.5 text-xs font-semibold ' + (task.status | badge)">{{ task.status }}</span>
            <span class="ms-auto text-xs" [class.font-semibold]="isOverdue(task.due_at)" [class.text-red-500]="isOverdue(task.due_at)" [class.text-gray-400]="!isOverdue(task.due_at)">{{
              task.due_at | date: 'mediumDate'
            }}</span>
          </div>
          <div class="text-sm text-gray-800">{{ task.title }}</div>
        </a>
      }
    }
    @if (!dataLoader && !myTasks?.length && !error) {
      <div class="flex h-full flex-col items-center justify-center gap-2 text-gray-400">
        <mat-icon fontIcon="task_alt" class="opacity-40 icon-size-8"></mat-icon>
        <span class="text-sm font-medium">No pending tasks</span>
      </div>
    }
  </div>
</fuse-card>
